import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isNotEmpty } from '../../utilities';

export interface UserBadgeCustomization {
  outerBoxWidth: string;
  outerBoxHeight: string;
  innerBoxWidth: string;
  innerBoxHeight: string;
}

@Component({
  selector: 'app-user-badge',
  templateUrl: './user-badge.component.html',
  styleUrls: ['./user-badge.component.scss'],
  standalone: false,
})
export class UserBadgeComponent implements OnChanges {
  @Input() badgeTheme: string = '1';

  @Input() username: string = '';
  @Input() width: number = 70;
  @Input() height: number = 70;
  @Input() fontSize: string = '25px';

  displayedInitials: string = '';
  userBadgeCustomization: UserBadgeCustomization = {} as UserBadgeCustomization;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.badgeTheme === '1' && this.adjustBadgeSize();
    this.displayedInitials = this.getUsernameInitials(this.username);
  }

  adjustBadgeSize() {
    this.userBadgeCustomization.outerBoxWidth = `${+this.width + 10}px`;
    this.userBadgeCustomization.outerBoxHeight = `${+this.height + 10}px`;
    this.userBadgeCustomization.innerBoxWidth = `${+this.width}px`;
    this.userBadgeCustomization.innerBoxHeight = `${+this.height}px`;
  }

  getUsernameInitials(username: string) {
    if (username) {
      const fullName = username.split(' ');
      let initials: string = '';
      if (isNotEmpty(fullName)) {
        initials = `${fullName.shift()?.charAt(0) ?? ''} ${fullName.pop()?.charAt(0) ?? ''}`;
      }

      return initials.toUpperCase();
    }
    return '';
  }
}
